import type { RefObject } from 'react';
import { useEffect, useState } from 'react';
import type {
  ThemeColor,
  ThemeColorProviderContextType,
} from '../components/unlisted/ThemeColorProvider';
import { useThemeColorProviderContext } from '../components/unlisted/ThemeColorProvider';

function useThemeScrollBlock(
  elementRef: RefObject<HTMLElement | null>,
  useAccent: boolean,
  accentColor?: ThemeColor,
  forceRefresh?: boolean,
): void {
  const [hasRefreshed, setHasRefreshed] = useState(false);

  const { registerBlock, removeBlock, setForceRefresh } =
    useThemeColorProviderContext() as ThemeColorProviderContextType;

  useEffect(() => {
    registerBlock(elementRef, useAccent, accentColor);
    if (forceRefresh && !hasRefreshed) {
      setForceRefresh((x) => x + 1);
      setHasRefreshed(true);
    }

    return () => {
      removeBlock(elementRef);
    };
  }, [
    elementRef,
    useAccent,
    registerBlock,
    removeBlock,
    accentColor,
    forceRefresh,
    hasRefreshed,
    setForceRefresh,
  ]);
}

export default useThemeScrollBlock;
